module.exports = __webpack_public_path__ + "img/login_bg.00c8a4df.png";